import base64 from "../base64";
import { safeParse } from "../safeParse";
import { tokenFieldName } from "../uid";
function getCookieValue(cookieString: string, key: string) {
  const regex = new RegExp(`(?:^|;\\s*)${key}=([^;]*)`, "g");
  const match = regex.exec(cookieString);
  return match ? decodeURIComponent(match[1]) : null;
}

export function getAccessTokenFromCookie(
  cookie: string
): string | undefined | null {
  let accessToken: string | undefined | null;

  const tokenValue = getCookieValue(cookie, tokenFieldName);

  if (tokenValue) {
    accessToken = safeParse(base64.decode(tokenValue))?.access_token;
  }

  return accessToken;
}
